import { api } from "../api";

// APIs do fluxo interno de solicitações (incluindo revisão dos anexos).

export const listProjectRequestIntake = async (status?: string) => {
  return api.get("/project-requests/intake", { params: status ? { status } : undefined });
};

export const getProjectRequestIntake = async (requestId: number) => {
  return api.get(`/project-requests/intake/${requestId}`);
};

export const updateProjectRequestChecklistItem = async (requestId: number, itemId: number, isChecked: boolean) => {
  return api.patch(`/project-requests/intake/${requestId}/checklist/${itemId}`, { isChecked });
};

export const createProjectRequestChecklistItem = async (requestId: number, content: string) => {
  return api.post(`/project-requests/intake/${requestId}/checklist/items`, { content });
};

export const updateProjectRequestChecklistItemContent = async (requestId: number, itemId: number, content: string) => {
  return api.patch(`/project-requests/intake/${requestId}/checklist/${itemId}`, { content });
};

export const deleteProjectRequestChecklistItem = async (requestId: number, itemId: number) => {
  return api.delete(`/project-requests/intake/${requestId}/checklist/${itemId}`);
};

export const replaceProjectRequestChecklist = async (requestId: number, templateId: number) => {
  return api.put(`/project-requests/intake/${requestId}/checklist`, { templateId });
};

export const convertProjectRequest = async (requestId: number, payload: unknown) => {
  return api.post(`/project-requests/intake/${requestId}/convert`, payload);
};

export const saveProjectRequestDraft = async (requestId: number, reviewedData: unknown) => {
  return api.put(`/project-requests/intake/${requestId}/draft`, { reviewedData });
};

export const requestProjectRequestComplement = async (requestId: number, message: string) => {
  return api.post(`/project-requests/intake/${requestId}/pending`, { message });
};

export const updateProjectRequestStatus = async (requestId: number, status: string, message?: string) => {
  return api.patch(`/project-requests/intake/${requestId}/status`, { status, message });
};

export const reviewProjectRequestAttachment = async (requestId: number, attachmentId: number, status: string, message?: string) => {
  return api.patch(`/project-requests/intake/${requestId}/attachments/${attachmentId}/review`, { status, message });
};

export const updateProjectRequestAttachmentCategory = async (requestId: number, attachmentId: number, category: string) => {
  return api.patch(`/project-requests/intake/${requestId}/attachments/${attachmentId}/category`, { category });
};

export const uploadProjectRequestIntakeAttachments = async (requestId: number, file: File, category: string, source: string, sourceNote: string) => {
  const formData = new FormData();
  formData.append("files", file);
  formData.append("category", category);
  formData.append("source", source);
  formData.append("sourceNote", sourceNote);
  return api.post(`/project-requests/intake/${requestId}/attachments`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getProjectRequestIntakeAttachmentFile = async (requestId: number, attachmentId: number) => {
  return api.get(`/project-requests/intake/${requestId}/attachments/${attachmentId}/file`, { responseType: "blob" });
};

export const markProjectRequestPowerOfAttorneyPrepared = async (requestId: number, reviewedData: unknown) => {
  return api.post(`/project-requests/intake/${requestId}/power-of-attorney/prepared`, { reviewedData });
};
